import { Box, Skeleton } from "@mui/material";

function AssetCardSkeleton() {
  return (
    <div className="asset-card" style={{ pointerEvents: "none" }}>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Skeleton variant="rectangular" width={6} height={40} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="80%" height={18} />
          <Skeleton variant="text" width="55%" height={14} />
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1.5, mb: 1 }}>
        <Skeleton variant="text" width="45%" height={14} />
        <Skeleton variant="rounded" width={56} height={20} />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>
    </div>
  );
}

export default function AssetListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="row">
      {Array.from({ length: count }).map((_, i) => (
        <div className="col-6 col-md-4 col-lg-4 mb-3" key={i}>
          <AssetCardSkeleton />
        </div>
      ))}
    </div>
  );
}
